import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { upcomingEvents, infoHealth } from '../Adapter/HomePageAdapter';
import { fetchRecentBlogs } from '../Adapter/PageAdapter';
import BlogImg from '../assets/images/blog1.png';
import { NavLink } from 'react-router-dom';
import greenBtnImg from "../assets/images/greenarwbtn.png";
import mapIconImg from "../assets/images/mpaicn.svg";
import { baseImage_path } from "../variables/Variables";

// Helper function to limit text to a specific word count
const truncateWords = (text, wordLimit = 25) => {
    if (!text) return "";
    const words = text.split(/\s+/);
    return words.length > wordLimit
        ? words.slice(0, wordLimit).join(" ") + "..."
        : text;
};

const InformationEvents = () => {

    const [infoPosts, setInfoPosts] = useState([]);      // For Better Information, Better Health
    const [events, setEvents] = useState([]);           // For Upcoming Events
    const [filteredEvents, setFilteredEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState("CME");
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const { slug } = useParams();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    // Fetch both APIs when the component mounts
    useEffect(() => {
        const fetchData = async () => {
            try {
                const [infoResponse, eventsResponse] = await Promise.all([
                    fetchRecentBlogs(),
                    upcomingEvents()
                ]);

                if (infoResponse && infoResponse.data) {
                    setInfoPosts(infoResponse.data.slice(0, 2));
                } else {
                    setError("Failed to load health information.");
                }

                if (eventsResponse && eventsResponse.data) {
                    setEvents(eventsResponse.data);
                    setFilteredEvents(
                        eventsResponse.data.filter((event) => event.event_type === "CME")
                    ); // Default to CME events
                } else {
                    setError("Failed to load upcoming events.");
                }
            } catch (err) {
                setError("An error occurred while fetching data.");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    // Handle Tab Click
    const handleTabClick = (tab) => {
        setActiveTab(tab);
        const filtered = events.filter((event) => event.event_type === tab);
        setFilteredEvents(filtered);
    };

    const handleViewEventDetails = (id, slug) => {
        const Fromatslug = slug.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)+/g, '');
        navigate(`/events/${Fromatslug}`);
    };

    const handleReadPost = (slug) => {
        navigate(`/blogs/${slug}`);
    };

    if (loading) return <div>Loading...</div>;
    if (error) return <div>{error}</div>;

    return (
        <>
            <section className="blog-events">
                <div className="cust-container">
                    <h2 className="section-title">Better <span>Information</span>, Better <span>Health</span></h2>

                    <div className="blog-section">
                        <div className="row">
                            {/* Mapping Better Info Health Data */}
                            {/* {infoPosts.map((post) => (
                                <div key={post.id} className="col-md-4">
                                    <div className="blog-card">
                                        <img
                                            src={post.featured_img ? `${baseImage_path}${post.featured_img}` : BlogImg}
                                            alt={post.title} style={{ height: '220px' }}
                                        />
                                        <div className="blog-card-content">
                                            <h3>{new Date(post.created_at).toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" })}</h3>
                                            <p>{truncateWords(post.title || "No Description Available", 25)}</p>
                                            <a href={`/blogs/${post.slug}`} className="btn">Read Post <img src={greenBtnImg} alt="" /></a>
                                        </div>
                                    </div>
                                </div>
                            ))} */}
                            {isMobile ? (
                                <Swiper
                                    modules={[Autoplay]}
                                    spaceBetween={16}
                                    slidesPerView={1.1}
                                    autoplay={{ delay: 3500 }}
                                    loop={true}
                                    className="mb-4"
                                >
                                    {infoPosts.map((post) => (
                                        <SwiperSlide key={post.id}>
                                            <div className="blog-card homImgBlog">
                                                <img
                                                    src={post.featured_img ? `${baseImage_path}${post.featured_img}` : BlogImg}
                                                    alt={post.title}
                                                    
                                                />
                                                <div className="blog-card-content">
                                                    <h3>{new Date(post.created_at).toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" })}</h3>
                                                    <p>{truncateWords(post.title || "No Description Available", 25)}</p>
                                                    <a href="#" onClick={() => handleReadPost(post.slug)} className="btn">Read Post <img src={greenBtnImg} alt="" /></a>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            ) : (
                                infoPosts.map((post) => (
                                    <div key={post.id} className="col-md-4">
                                        <div className="blog-card">
                                            <img
                                                src={post.featured_img ? `${baseImage_path}${post.featured_img}` : BlogImg}
                                                alt={post.title}
                                                style={{ height: "220px" }}
                                            />
                                            <div className="blog-card-content">
                                                <h3>{new Date(post.created_at).toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" })}</h3>
                                                <p>{truncateWords(post.title || "No Description Available", 25)}</p>
                                                <a href="#" onClick={() => handleReadPost(post.slug)} className="btn">Read Post <img src={greenBtnImg} alt="" /></a>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )}

                            {/* Upcoming Events Section */}
                            <div className="col-md-4">
                                <div className="blog-card events-section">
                                    <h2>Events</h2>
                                    {/* Tabs for CME, Camps, and Others */}
                                    <div className="blogtabs tabs">
                                        <a
                                            href="#"
                                            className={`btn ${activeTab === "CME" ? "with-clor active" : "without-color"}`}
                                            onClick={(e) => {
                                                e.preventDefault(); // Prevent scrolling to the top
                                                handleTabClick("CME");
                                            }}
                                        >
                                            CME
                                        </a>
                                        <a
                                            href="#"
                                            className={`btn ${activeTab === "Camps" ? "with-clor active" : "without-color"}`}
                                            onClick={(e) => {
                                                e.preventDefault(); // Prevent scrolling to the top
                                                handleTabClick("Camps");
                                            }}
                                        >
                                            Camps
                                        </a>
                                        <a
                                            href="#"
                                            className={`btn ${activeTab === "Others" ? "with-clor active" : "without-color"}`}
                                            onClick={(e) => {
                                                e.preventDefault(); // Prevent scrolling to the top
                                                handleTabClick("Others");
                                            }}
                                        >
                                            Others
                                        </a>
                                    </div>

                                    <div className="my-evnt">
                                        {/* Mapping Upcoming Events */}
                                        {filteredEvents.length > 0 ? (
                                            filteredEvents.map((event) => (
                                                <div key={event.id} className="event">
                                                    <div className="event-date">
                                                        <h3>{new Date(event.start_event_date).getDate()}</h3>
                                                        <p>
                                                            {new Date(event.start_event_date).toLocaleString("default", {
                                                                month: "short",
                                                            })}
                                                        </p>
                                                    </div>
                                                    <div className="event-info">
                                                        {/* <h4>{event.heading}</h4> */}
                                                        {/* <p>{truncateWords(event.description || "No Dscription Available", 20)}</p> */}
                                                        <p className="ck-content" dangerouslySetInnerHTML={{ __html: truncateWords(event.description || "No Dscription Available", 20)  }} />
                                                        <p>
                                                            <img src={mapIconImg} alt="" /> {event.location}
                                                        </p>
                                                        <a href="#" className="btn" onClick={() => handleViewEventDetails(event.id, event.slug)}>
                                                            View Details<img src={greenBtnImg} alt="" />
                                                        </a>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <p>No events available for {activeTab}.</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="view-all">
                        <NavLink to="/events">View All</NavLink>
                    </div>
                </div>
            </section>
        </>
    )
}

export default InformationEvents;